import graphql__daf09b50efc91c9d5b0b from "./__generated__/StoreViewerCookiesConsentmentMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__daf09b50efc91c9d5b0b;

function storeViewerCookiesConsentment(accepts, onCompleted) {
  return commitMutation(appRelayEnvironment, {
    mutation,
    variables: { accepts },
    onCompleted,
    onError: error => console.error(error)
  });
}

export { storeViewerCookiesConsentment };
